import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "col-span-3" }
const _hoisted_2 = { class: "col-span-3 flex items-center" }
const _hoisted_3 = {
  class: "whitespace-nowrap mr-1",
  style: {"flex":"0 0 70px"}
}
const _hoisted_4 = { class: "col-span-3" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"grid grid-cols-[repeat(11,_minmax(0,_1fr))_35px] gap-3 font-bold py-2\"><span class=\"col-span-3\">Valuta</span><span class=\"col-span-3\">Valore in euro</span><span class=\"col-span-3\">Dati di cambio</span><span class=\"col-span-1\">Pred. A</span><span class=\"col-span-1\">Pred. V</span></div>", 1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.valute_data, (f, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid grid-cols-[repeat(11,_minmax(0,_1fr))_35px] gap-3 mb-3",
        key: i
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Field, {
            modelValue: f.descrizione,
            "onUpdate:modelValue": ($event: any) => ((f.descrizione) = $event),
            "label-visible": false,
            placeholder: "Valuta"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                searchable: true,
                "internal-search": false,
                trackBy: "CG08_SIGLA",
                label: "CG08_DESCR",
                onSearchChange: _ctx.valutaAutcomplete.search,
                modelValue: f.valuta,
                "onUpdate:modelValue": [($event: any) => ((f.valuta) = $event), ($event: any) => (_ctx.setValuta(f, $event))],
                options: _ctx.valutaAutcomplete.options,
                "close-on-select": true,
                "clear-on-select": true,
                placeholder: "Valuta",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona",
                class: "next-vue-multiselect-single"
              }, null, 8, ["onSearchChange", "modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "1 " + _toDisplayString(f.valuta?.CG08_SIGLA) + " = ", 1),
          _createVNode(_component_Field, {
            modelValue: f.valore,
            "onUpdate:modelValue": ($event: any) => ((f.valore) = $event),
            "label-visible": false,
            placeholder: "Valore in euro",
            type: "number",
            "input-attrs": {step:0.000001}
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "whitespace-nowrap ml-1" }, "€", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            modelValue: f.data,
            "onUpdate:modelValue": ($event: any) => ((f.data) = $event),
            "label-visible": false,
            type: "date"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Radio, {
            value: i,
            name: "default_acq",
            modelValue: _ctx.default_acq,
            "onUpdate:modelValue": _ctx.updateValAcq,
            checkClass: "w-3 h-3"
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Radio, {
            value: i,
            name: "default_ve",
            modelValue: _ctx.default_ve,
            "onUpdate:modelValue": _ctx.updateValVe,
            checkClass: "w-3 h-3"
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue"])
        ]),
        (i === _ctx.valute_data.length-1)
          ? (_openBlock(), _createBlock(_component_NextButton, {
              key: 0,
              variant: "primary",
              onClick: _ctx.addValuta,
              class: "flex justify-center items-center"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
              ])),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_NextButton, {
              key: 1,
              variant: "outline-secondary",
              onClick: ($event: any) => (_ctx.removeValuta(i)),
              class: "flex justify-center items-center"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "icon-x" }, null, -1)
              ])),
              _: 2
            }, 1032, ["onClick"]))
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _ctx.chiudi,
        class: "col-start-4 col-span-3 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.salva,
        class: "col-span-3 ml-4 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Salva ")
        ])),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}